import { createApp } from 'vue'
import { createPinia } from 'pinia'
import WebApp from '@twa-dev/sdk'

import App from './App.vue'
import router from './router'
import { i18n } from './locales'
import './assets/styles/main.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
  faXTwitter,
  faTelegram,
  faYoutube,
  faCcMastercard
} from '@fortawesome/free-brands-svg-icons'
import {
  faXmark,
  faAngleRight,
  faAnglesRight,
  faArrowLeft,
  faUserPlus,
  faLink,
  faCopy,
  faShieldHalved,
  faFileLines,
  faGlobe,
  faUserXmark,
  faMagnifyingGlass,
  faCheck,
  faArrowRightArrowLeft,
  faArrowDown,
  faAngleDown,
  faArrowRight,
  faClockRotateLeft,
  faLock,
  faUserAstronaut,
  faSkull,
  faDollarSign,
  faBan
} from '@fortawesome/free-solid-svg-icons'
import {
  faUser as farUser,
  faBookmark,
  faCalendar,
  faEye
} from '@fortawesome/free-regular-svg-icons'

import {
  createTonConnectUIProvider,
  TonConnectUIContext,
  TonConnectUIOptionsContext
} from 'ton-ui-vue'

const { tonConnectUI, setOptions } = createTonConnectUIProvider({
  manifestUrl:
    'https://gist.githubusercontent.com/siandreev/75f1a2ccf2f3b4e2771f6089aeb06d7f/raw/d4986344010ec7a2d1cc8a2a9baa57de37aaccb8/gistfile1.txt'
})

/* add icons to the library */
library.add(
  faXmark,
  faAngleRight,
  faAnglesRight,
  faEye,
  faXTwitter,
  faCalendar,
  faBookmark,
  faCheck,
  faArrowDown,
  faTelegram,
  faYoutube,
  faClockRotateLeft,
  faArrowRight,
  faArrowLeft,
  farUser,
  faCcMastercard,
  faUserPlus,
  faLink,
  faCopy,
  faShieldHalved,
  faFileLines,
  faArrowRightArrowLeft,
  faGlobe,
  faUserXmark,
  faMagnifyingGlass,
  faCheck,
  faUserXmark,
  faArrowDown,
  faAngleDown,
  faLock,
  faUserAstronaut,
  faSkull,
  faDollarSign,
  faBan
)

const app = createApp(App)
WebApp.ready()
WebApp.expand()
WebApp.BackButton.onClick(() => {
  router.back()
})
console.log('WEB APP', WebApp)

app.provide(TonConnectUIContext, tonConnectUI)
app.provide(TonConnectUIOptionsContext, setOptions)

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')
